import { ApiClient } from "../utils/api-client";

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "api-key": process.env.REACT_APP_API_KEY || "lChjFRJce3bxmoS3TSQk5w==",
  },
};

const apiClient = new ApiClient(API_CONFIG);

export type HealthAssessmentQuestionnaireResponse = {
  code: string;
  data: any[];
};

export const healthAssessmentService = {
  async getAssessmentsList(): Promise<any> {
    // TODO: Replace with actual health assessment endpoint
    const res = await apiClient.get<any>(
      "/api/v8/gfc/health_assessment/config",
      { encrypted: true }
    );
    return res.data;
  },

  async logHealthAssessment(payload: any): Promise<any> {
    // TODO: Replace with actual health assessment submission endpoint
    const res = await apiClient.post<any>(
      "/api/v8/patient/patient_health_assessment_log",
      payload,
      {
        encrypted: true,
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );
    return res.data;
  },
};
